import AttachmentButton from './component';

export default AttachmentButton;
